import I18n from 'I18n';
import { List } from 'immutable';
import SearchViewFilterRecord from 'SalesContentIndexUI/data/records/SearchViewFilterRecord';
import filter from 'SalesContentIndexUI/data/utils/filter';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
const getTeamFilters = ({
  looseItemContentType,
  folderContentType,
  teamIds
}) => {
  const filterContentType = filter(SearchFields.CONTENT_TYPE_FIELD, looseItemContentType, folderContentType);
  const filterByTeamId = filter(SearchFields.TEAM_ID_FIELD, ...teamIds);
  return List([filterContentType, filterByTeamId]);
};
const hideAllContentFilters = () => {
  const hideLooseItems = filter(SearchFields.CONTENT_TYPE_FIELD);
  const hideFolders = filter(SearchFields.FOLDER_ID_FIELD);
  return List([hideLooseItems, hideFolders]);
};
export const MyTeamViewFilter = ({
  looseItemContentType,
  folderContentType,
  getTeamIds,
  sort,
  useOwnerViewFilters
}) => SearchViewFilterRecord({
  id: useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_MY_TEAM : DefaultFilterNames.CREATED_BY_MY_TEAM,
  getFilters: () => {
    const teamIds = getTeamIds();
    return teamIds ? getTeamFilters({
      looseItemContentType,
      folderContentType,
      teamIds
    }) : hideAllContentFilters();
  },
  getSort: () => sort || DefaultSort,
  getDisabledTooltipCopy: () => I18n.text('salesContentIndexUI.search.notAddedToATeam'),
  isDisabled: () => !getTeamIds()
});
export const TeamViewFilter = ({
  looseItemContentType,
  folderContentType,
  sort,
  id
}) => SearchViewFilterRecord({
  id: `${DefaultFilterNames.TEAM}-${id}`,
  type: DefaultFilterNames.TEAM,
  getFilters: () => getTeamFilters({
    looseItemContentType,
    folderContentType,
    teamIds: [id]
  }),
  getSort: () => sort || DefaultSort
});